const isPushSupported = (): boolean => {
  return !!navigator?.serviceWorker && typeof Notification !== 'undefined';
};

export default isPushSupported;
